import { useEffect, useRef, useCallback } from "react";
import { sileo } from "sileo";

function UpdateNotification() {
  const toastShownRef = useRef(false);

  const applyUpdate = useCallback(async () => {
    if (!navigator.serviceWorker) return;
    try {
      const registration = await navigator.serviceWorker.getRegistration();
      if (!registration?.waiting) return;
      console.log("[PWA] Aplicando actualización...");
      registration.waiting.postMessage({ type: "SKIP_WAITING" });
    } catch (error) {
      console.error("[PWA] Error al aplicar actualización:", error);
    }
  }, []);

  const showToast = useCallback(() => {
    if (toastShownRef.current) return;
    toastShownRef.current = true;

    // Listener nativo porque Sileo renderiza el JSX fuera del árbol React
    const handler = (e) => {
      if (e.target.closest("[data-pwa-update]")) {
        applyUpdate();
      }
    };
    document.addEventListener("click", handler);

    sileo.info({
      title: "¡Nueva versión disponible!",
      description: (
        <button
          data-pwa-update="true"
          style={{
            marginTop: 6,
            padding: "6px 16px",
            border: "none",
            borderRadius: 6,
            background: "#1976d2",
            color: "#fff",
            fontWeight: 600,
            cursor: "pointer",
            fontSize: "0.85rem",
          }}
        >
          Actualizar ahora
        </button>
      ),
      duration: 24 * 60 * 60 * 1000,
    });
  }, [applyUpdate]);

  useEffect(() => {
    if (!navigator.serviceWorker) return;

    const checkWaiting = async () => {
      try {
        const registration = await navigator.serviceWorker.getRegistration();
        if (!registration) return;
        console.log("[PWA] Verificando actualizaciones...");
        await registration.update();
        if (registration.waiting) {
          console.log("[PWA] Nueva versión ya disponible");
          showToast();
        }
      } catch (error) {
        console.error("[PWA] Error al verificar actualizaciones:", error);
      }
    };

    const onUpdateFound = () => {
      navigator.serviceWorker.getRegistration().then((reg) => {
        const newWorker = reg?.installing;
        if (!newWorker) return;
        newWorker.addEventListener("statechange", () => {
          if (
            newWorker.state === "installed" &&
            navigator.serviceWorker.controller
          ) {
            console.log("[PWA] Nueva versión instalada y lista");
            showToast();
          }
        });
      });
    };

    const handleControllerChange = () => {
      console.log("[PWA] Service Worker actualizado - Recargando...");
      window.location.reload();
    };

    navigator.serviceWorker.getRegistration().then((reg) => {
      if (reg) reg.addEventListener("updatefound", onUpdateFound);
    });
    navigator.serviceWorker.addEventListener(
      "controllerchange",
      handleControllerChange,
    );

    checkWaiting();
    const intervalId = setInterval(checkWaiting, 15 * 60 * 1000);

    return () => {
      clearInterval(intervalId);
      navigator.serviceWorker.removeEventListener(
        "controllerchange",
        handleControllerChange,
      );
      navigator.serviceWorker.getRegistration().then((reg) => {
        if (reg) reg.removeEventListener("updatefound", onUpdateFound);
      });
    };
  }, [showToast]);

  // Exponer forceUpdate global para depuración
  useEffect(() => {
    window.forcePWAUpdate = async () => {
      if (!navigator.serviceWorker) return;
      try {
        const registration = await navigator.serviceWorker.getRegistration();
        if (!registration) return;
        if (registration.waiting) {
          registration.waiting.postMessage({ type: "SKIP_WAITING" });
        } else {
          await registration.update();
        }
      } catch (error) {
        console.error("[PWA] Error al forzar actualización:", error);
      }
    };
  }, []);

  return null;
}

export default UpdateNotification;
